import { createSlice } from '@reduxjs/toolkit'

export interface NetworkingState {
  allUsers: {
    [id: string]: {
      companyName: string
      email: string
      name: string
      profileUrl: string
    }
  }
}

const initialState: NetworkingState = {
  allUsers: {},
}

export const networkingSlice = createSlice({
  name: 'networking',
  initialState: initialState,
  reducers: {
    setAllUsers: (state, action) => {
      state.allUsers = action.payload
    },
  },
})

export const { setAllUsers } = networkingSlice.actions

export default networkingSlice.reducer
